(() => {
  const SECTION_SELECTOR = '.section-header-top-links-v2';
  const CUSTOM_SELECTOR = '[data-header-top-links-custom]';
  const VIEWPORT_SELECTOR = '[data-header-top-links-viewport]';
  const MARQUEE_SELECTOR = '[data-header-top-links-marquee]';
  const COPY_SELECTOR = '[data-header-top-links-copy]';
  const CLONE_ATTRIBUTE = 'data-header-top-links-clone';
  const activeSections = new Set();

  const updateSection = (section) => {
    const custom = section.querySelector(CUSTOM_SELECTOR);
    const viewport = section.querySelector(VIEWPORT_SELECTOR);
    const marquee = section.querySelector(MARQUEE_SELECTOR);
    const copy = section.querySelector(COPY_SELECTOR);

    if (!custom || !viewport || !marquee || !copy) return;

    marquee.querySelectorAll(`[${CLONE_ATTRIBUTE}]`).forEach((node) => node.remove());
    custom.classList.remove('is-overflowing');
    marquee.style.removeProperty('--header-top-links-v2-marquee-distance');
    marquee.style.removeProperty('--header-top-links-v2-marquee-duration');

    if (copy.scrollWidth <= viewport.clientWidth + 1) return;

    const clone = copy.cloneNode(true);
    clone.setAttribute(CLONE_ATTRIBUTE, 'true');
    clone.removeAttribute('data-header-top-links-copy');
    marquee.appendChild(clone);

    const gap = 24;
    const distance = copy.scrollWidth + gap;
    const duration = Math.max(8, distance / 32);

    custom.classList.add('is-overflowing');
    marquee.style.setProperty('--header-top-links-v2-marquee-distance', `${distance}px`);
    marquee.style.setProperty('--header-top-links-v2-marquee-duration', `${duration}s`);
  };

  const initSection = (section) => {
    if (!section || activeSections.has(section)) return;

    const custom = section.querySelector(CUSTOM_SELECTOR);
    if (!custom) return;

    activeSections.add(section);
    updateSection(section);
  };

  const initSections = (scope = document) => {
    if (scope.matches && scope.matches(SECTION_SELECTOR)) {
      initSection(scope);
    }

    scope.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
  };

  const updateAllSections = () => {
    activeSections.forEach(updateSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initSections());
  } else {
    initSections();
  }

  window.addEventListener('resize', updateAllSections);
  window.addEventListener('load', updateAllSections);

  document.addEventListener('shopify:section:load', (event) => {
    initSections(event.target);
    updateAllSections();
  });
})();
